import { BiXCircle } from "react-icons/bi";
import { ClickableIcon } from "../comments/CommentsAction";
import { Note } from "../../../types/modulesInterfaces";
import NoteTextEditor from "./NoteTextEditor";
import { useIconSize } from "@app/hooks";

interface NoteEditorProps {
  notes: Note | null;
  onSave: (content: string) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  errorMessage?: string;
}

export const NoteEditor = ({
  notes,
  onSave,
  onCancel,
  isLoading = false,
  errorMessage = ""
}: NoteEditorProps) => {
  const iconSize = useIconSize(20);
  return (
    <>
      <div className="d-flex justify-content-end align-self-end">
        <ClickableIcon clickHandler={onCancel}>
          <BiXCircle size={iconSize} />
        </ClickableIcon>
      </div>
      <NoteTextEditor
        notes={notes?.content ?? null}
        onSave={onSave}
        isLoading={isLoading}
        errorMessage={errorMessage}
      />
    </>
  );
}; 